<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)" v-if="categoryBoardType">
                在途板材
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)" v-if="categoryRawType">
                在途原木
            </div>
            <div :class="['navSon',tab==3?'navSonChecked':'']" @click="changeTab(3)" v-if="categoryScrapType">
                在途集成材
            </div>
        </div>
        <purchaseMidwayBoard v-if="tab == 1"></purchaseMidwayBoard>
        <purchaseMidwayWood v-if="tab == 2"></purchaseMidwayWood>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                tab : 1
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            }
        }
    }
</script>
<style scoped>

</style>